import React, { useEffect, useRef, useState } from 'react';
import { Grid, Box, IconButton, Typography } from '@material-ui/core';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import FastForwardIcon from '@material-ui/icons/FastForward';
import FastRewindIcon from '@material-ui/icons/FastRewind';

const VideoPlayer = ({ videoJsOptions }) => {
  const videoNode = useRef(null);
  const [currentTime, setCurrentTime] = useState(null);

  const getVideoplayerInstance = async () => await videojs(videoNode.current);

  const handleTimeJump = async (type) => {
    getVideoplayerInstance().then((player) => {
      player.pause();
      let currentTime = player.currentTime();
      if (type) {
        type === 'inc'
          ? setCurrentTime(currentTime + 15)
          : currentTime > 15
          ? setCurrentTime(currentTime - 15)
          : setCurrentTime(0);
      }
    });
  };

  useEffect(() => {
    const player = videojs(
      videoNode.current,
      videoJsOptions,
      function onPlayerReady() {
        console.log('onPlayerReady');
      },
    );

    if (!videoJsOptions.sources[0].src) {
      console.log('no source found');
    }
    return () => {
      if (player) {
        player.dispose();
      }
    };
  }, []);

  useEffect(() => {
    getVideoplayerInstance().then((player) => player.currentTime(currentTime));
  }, [currentTime]);

  return (
    <Box display="flex" flexDirection="column">
      <div data-vjs-player style={{ width: '100%' }}>
        <video
          ref={videoNode}
          className="video-js vjs-big-play-centered"
          height="400"
        />
      </div>
      <Box display="flex" justifyContent="space-between">
        <IconButton onClick={() => handleTimeJump('dec')}>
          <FastRewindIcon color="primary" />
          <Typography variant="subtitle2">-15s</Typography>
        </IconButton>
        <IconButton onClick={() => handleTimeJump('inc')}>
          <Typography variant="subtitle2">+15s</Typography>
          <FastForwardIcon color="primary" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default VideoPlayer;
